import { createSelector } from "reselect";
import getLocationMetadata from "../base_getters/get_location_metadata";

const getPageName = createSelector([
  getLocationMetadata
], (locationMetadata) => locationMetadata.pageName || null);


export default getPageName;